<script setup lang="ts">
import { BellIcon } from '@lucide/vue'

type Props = {
  hasUnread?: boolean
  isMobile?: boolean
}

defineProps<Props>()
</script>

<template>
  <button
    type="button"
    title="Notifications"
    class="shrink-0 relative flex items-center justify-center rounded-ds-md text-muted-foreground hover:bg-background hover:text-foreground transition-colors duration-ds-fast ease-ds-standard cursor-pointer"
    :class="isMobile ? 'size-11' : 'size-10'"
  >
    <BellIcon
      :class="isMobile ? 'size-5.25' : 'size-5'"
      aria-hidden="true"
    />
    <span
      v-if="hasUnread"
      class="absolute size-2.25 top-2.25 rounded-full bg-primary border-2 border-card"
      :class="isMobile ? 'right-3' : 'right-2.5'"
      aria-hidden="true"
    />
  </button>
</template>
